import React from "react";
import { Tag } from "antd";
import { pillTagStyle } from "./styles";

const PillTag = ({ children, style, ...rest }) => (
  <Tag style={{ ...pillTagStyle, ...style }} {...rest}>
    {children}
  </Tag>
);

export default PillTag;
